import { motion } from "framer-motion";

const events = [
  {
    year: "1723",
    title: "Der Bauernhof entsteht",
    text: "Auf dem Gelände der heutigen Schattbachstraße 77 in Bochum-Laer wird ein Bauernhof erbaut – ein Ort, der über Jahrhunderte Geschichte schreiben wird.",
    color: "#D4A843",
  },
  {
    year: "2009",
    title: "Klaus Teichmann kauft den Hof",
    text: "Künstler Klaus Teichmann (geb. 1964 in Herne) entdeckt das historische Gehöft und erwirbt es. Seine Vision: ein Raum für Freidenker und frei schaffende Künstler im Herzen des Ruhrgebiets.",
    color: "#C1440E",
  },
  {
    year: "2010",
    title: "Umbau zum Künstlerhof",
    text: "In aufwändiger Renovierungsarbeit entsteht das Atelier 77 – Partyscheune, Außengelände und Atelier. 'Art meets Party' wird zum Leitmotiv einer einzigartigen Location.",
    color: "#D4A843",
  },
  {
    year: "Heute",
    title: "Atelier 77 – Art meets Party",
    text: "Pharmaunternehmen, Museen, Medienanstalten, Film- und Computerspielproduktionen sowie Privatpersonen feiern hier. Die Mischung aus Kunsthof-Atmosphäre und Eventlocation ist einzigartig im Ruhrgebiet.",
    color: "#C1440E",
  },
];

export default function Timeline() {
  return (
    <div className="relative" data-testid="timeline">
      <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-[#D4A843]/50 via-[#C1440E]/30 to-transparent" />

      <div className="flex flex-col gap-14 md:gap-16">
        {events.map((event, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className={`relative pl-12 md:pl-0 flex ${
              i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
            } gap-0`}
            data-testid={`timeline-event-${i}`}
          >
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 + 0.2, type: "spring" }}
              className="absolute left-1.5 md:left-1/2 md:-translate-x-1/2 top-1 w-5 h-5 rounded-full border-2 flex items-center justify-center z-10"
              style={{ borderColor: event.color, backgroundColor: "#141414" }}
            >
              <div className="w-2 h-2 rounded-full" style={{ backgroundColor: event.color }} />
            </motion.div>

            <div
              className={`w-full md:w-[45%] ${
                i % 2 === 0 ? "md:pr-16 md:text-right" : "md:pl-16 md:ml-[55%]"
              }`}
            >
              <span
                className="text-4xl md:text-5xl font-extrabold block mb-2 leading-none"
                style={{ fontFamily: "'Barlow Condensed', sans-serif", color: event.color }}
              >
                {event.year}
              </span>
              <h3
                className="text-xl font-semibold text-[#F2EDE8] mb-3"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {event.title}
              </h3>
              <p
                className="text-[#A19D98] text-sm leading-relaxed"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {event.text}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
